import React from 'react'

import { SchoolPage_school } from 'main/pages/School/gql'
import ProgramInfomation from './ProgramInfomation'

interface IProps {
  school: SchoolPage_school
  licenseExempt?: boolean
}

export default function LicenseInformationSection(props: IProps) {
  const { school } = props
  const {
    address,
    programType,
    licenseStatus,
    externalSchoolLicenseNumber,
    licenseNumber,
    profile,
    slug,
  } = school

  return (
    <ProgramInfomation
      address={address}
      programType={programType}
      licenseStatus={licenseStatus}
      licenseNumber={licenseNumber || externalSchoolLicenseNumber}
      externalLicenseUrl={profile?.externalLicenseUrl}
      slug={slug}
    />
  )
}
